var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"loading-wrapper"},[_c('div',{staticClass:"line"}),_c('div',{staticClass:"subline inc"}),_c('div',{staticClass:"subline dec"})])])}
var staticRenderFns = []

export { render, staticRenderFns }